import moment from 'moment-timezone';
import { api } from '@/f1/service';
import codes from '@/f1/codes';
import DatePicker from 'vue2-datepicker';
import custom from '@/f1/custom';
import Language from './language';

//restful api
// import { wsfinder as wf } from '@/f1/service/api';

//i18n_data
import fields from './i18n_data'
import i18n_data from '@/component/i18n_data';


// const _i18n_data = {
//   username: {
//     EN : () => `Username required.`,
//     KO : () => `아이디를 입력하세요.`,
//     JP : () => `Username required.`,
//   },
//   password: {
//     EN : () => `Password required.`,
//     KO : () => `비밀번호를 입력하세요.`,
//     JP : () => `Password required.`,
//   }
// };
const default_opt = () => ({
  perPage: 10, //limit,
  currentPage: 1, //
  totalRows: 0,
  adv : false,
  sk : '', sv : '', skt : '', "opt" : { category : [], type : [], ext : [] }
})

export default {
  components: { DatePicker, Language },
  data: () => {
    return {
      custom,
      codes,
      show: true,
      so : default_opt(),
      oo : [],
      search : { target: 'pattern', cmd : 'list', body: { and: [{name : 'is_del', value: false, op : '='}], or: [], sort: [{ name: 'id', op : 'desc'}] } }
    }
  },
  computed: {
    // i18n_data() { return _i18n_data; },
    category() { return this.so.opt.category; },
    type() { return this.so.opt.type; },
    ext() { return this.so.opt.ext; },
    fields() { return fields.i18n_fields[this.i18n]; },
    rowCount: function() { return this.so.totalRows || 0; },
    startRow : function() { return this.so.totalRows - (this.so.currentPage - 1) * this.so.perPage; }
  },
  watch : {
    ext(){
      this.search.body.or = []
      for(let [key, value] of Object.entries(this.so.opt.ext)){
        switch(key){
          default : this.search.body.or.push({name : 'ext', value : value, op : '='}); break;
        }
      }
    },
    type(){
      this.search.body.or = []
      for(let [key, value] of Object.entries(this.so.opt.type)){
        switch(key){
          default : this.search.body.or.push({name : 'type', value : Number(value), op : '='}); break;
        }
      }
    },
    category(){
      this.search.body.or = []
      for(let [key, value] of Object.entries(this.so.opt.category)){
        switch(key){
          default : this.search.body.or.push({name : 'category', value : value, op : '='}); break;
        }
      }
    }
  },
  methods: {
    reset() { this.so = default_opt(); this.refresh(); },
    refresh() { this.$refs._list.refresh(); },
    getItems: function(ctx) { return this.load(ctx); },
    async load(ctx = {}) {
      let so = {
        ok : ctx.sortBy,
        od : ctx.sortDesc ? 'd' : 'a',
        pg : ctx.currentPage || this.so.currentPage || 1,
        pc : ctx.perPage || this.so.perPage || 10,
        sk : this.so.sk,
        sv : this.so.sv,
        opt: this.so.adv ? Object.assign({}, this.so.opt) : {}
      }
      // this.search = { target: 'pattern', cmd : 'list',limit: so.pc, offset: (so.pg - 1) * so.pc, body: { and: [{name : 'is_del', value: false, op : '='}], or: [], sort: [{ name: 'id', op : 'desc'}] } }
      this.search.limit = so.pc;
      this.search.offset = (so.pg - 1) * so.pc
      this.search.body.and = [{name : 'is_del', value: false, op : '='}]
      if(ctx.sortBy) { this.search.body.sort = [ { name : ctx.sortBy, op : ctx.sortDesc && 'desc' } ]; }
      if((this.so.sv || '').trim()) { this.search.body.and = [ { name : 'code', value : `%${this.so.sv}%`, op : 'like' } ] }
      if(so.sk && so.sv) {
        const value = so.sv.replace(/\*/g, '%');
        for(let key of so.sk.split(',')) {
          this.search.body.or.push({"name": key, "value": `%${value}%`, "op": 'like' });
        }
      }
      // search (adv)
      for (let [key, value] of Object.entries(so.opt)) {
        switch(key) {
          case 'is_alive' : this.search.body.and.push({name: 'is_alive', value: value, op: '=' }); break;
          case 'created_at_sd' : this.search.body.and.push({name: 'created_at', value: moment(value).valueOf(), op: '>=' }); break;
          case 'created_at_ed' : this.search.body.and.push({name: 'created_at', value: moment(value).add(1, 'd').valueOf(), op: '<=' }); break;
          // default: this.search.body.and.push({name: key, value: value, op: /[%\*]/.test(value) ? 'like' : '=' }); break;
        }
      }
      try {
        let rs = await api.wsfinder.WSFinder(this.search); this.so.totalRows = rs.total; return rs.body;
        //let rs = await wf.pattern.list(this.search); this.so.totalRows = rs.total; return rs.body;
      } catch(e) { this.$toastr.e(e.data ? `${i18n_data._i18n_error.load_failed[this.i18n]}` : e.data.message ? e.data.message : e.statusText)  }
    },
    detail: function(item) { this.$router.push(`pattern/${item.id}`); },
    hideList: function(e) {
      this.show = !e; console.log('pattern.list.vue', 'got event (list show/hide)', !e ? 'show' : 'hide')
    }
  },
  created: function() {   console.log('pattern.list.vue', 'created'); },
  destroyed: function() { console.log('pattern.list.vue', 'destroyed'); },
  mounted: function() { console.log('pattern.list.vue', 'mounted'); },
}
